/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import {Link} from "react-router-dom";

import AppNavbar from "../../InternetNavbar";
import AppFooter from "../../../components/AppFooter";
import NotFound from "../../../components/NotFound";
import Loading from "../../../components/Loading";

import {toCompactAmount} from "../../../helpers/IspScoreHelper";

import {linkForPlace} from "../../LinkHelper";
import {getCountryCode3} from "../../place/GeoCountries";

import ChoroplethMap from "./ChoroplethMap";

class OutageTrends extends Component {

    constructor(props) {
            super(props);
            this.state = {
                probeInfo: {},
                isLoading: true,
                isFound: false,
            };
        }

    validateRestResponse(response) {
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(response) {
        this.setState({probeInfo: {}, isLoading: false, isFound: false});
    }

    componentDidMount() {
        this.setState({isLoading: true, isFound: false});


        const url = '/rest/internet/probesinfo';

        fetch(url)
            .then(response => this.validateRestResponse(response))
            .then(response => response.json())
            .then(data => {
                this.setState({probeInfo: data, isLoading: false, isFound: true});
            })
            .catch(e => this.catchRestError(e))
        ;
    }

    formatPercentage(val) {
            //let res = val.toFixed(1);
            //if (res[res.length - 1] === "0") return res.substr(0, res.length - 2) + "%";
            if (val>0) return '+'+val.toFixed(3) + "%";
            return ''+val.toFixed(3) + "%";
    }

    renderProbeInfo(info, rowid, isOdd) {
        let region = info.countryRegion;

        // let impactToday = this.formatPercentage(info.impactPerc24h*100);
        // let trendDev24h = this.formatPercentage(info.trendDev24h*100);
        let trendDev7d = this.formatPercentage(info.trendDev7d*100);
        let trendDev30d = this.formatPercentage(info.trendDev30d*100);

        let rowClass = isOdd ? "odd" : "even";

        // let tdc24h = info.trendDev24h>=0.01 ? 'text-danger' : info.trendDev24h>0 ? 'text-warning' : info.trendDev24h<0 ? 'text-success': 'text-dark'; 
        let tdc7d  = info.trendDev7d>=0.01  ? 'text-danger' : info.trendDev7d>0 ? 'text-warning' : info.trendDev7d<0 ? 'text-success': 'text-dark';
        let tdc30d = info.trendDev30d>=0.01 ? 'text-danger' : info.trendDev30d>0 ? 'text-warning' : info.trendDev30d<0 ? 'text-success': 'text-dark';

        return (
            <tr role="row" key={rowid} className={rowClass}>
                <td><Link to={linkForPlace(info.countryName)}>{info.countryName}</Link>
                           {region && <Link to={linkForPlace(info.countryName, region)}>, {region}</Link>}</td>
                
                <td className={tdc30d}>{trendDev30d}</td>
                <td className={tdc7d}>{trendDev7d}</td>
                <td>{toCompactAmount(info.total)}</td>
            </tr>
        );
    }

    render() {
        const {probeInfo, isLoading, isFound} = this.state;

        if (isLoading) {
            return <Loading/>
        }

        if (!isFound) {
            return <NotFound/>;
        }

        var self = this;
        /*const reducedDay = probeInfo.infos.reduce(function(m, pi){
            const cc3 = getCountryCode3(pi.countryCode);
            if(!m[cc3]) {
                m[cc3] = [pi.trendDev24h*100, pi.total];
                return m;
            }
            let cur = m[cc3];
            let newTotal=pi.total+cur[1];
            let newTrend = (cur[0]*cur[1]+pi.trendDev24h*100*pi.total)/newTotal;
            m[cc3] = [newTrend, newTotal];
            return m;
        },{});
        let dataDay = Object.keys(reducedDay).map(function(k) {
            let value = reducedDay[k][0]>0 ? reducedDay[k][0]*10000 : 1;
            return [k, reducedDay[k][0], '<strong>'+self.formatPercentage(reducedDay[k][0])+'</strong> daily trend'];
        });
        dataDay = dataDay.filter(i => i[1]>0);

        const reducedWeek = probeInfo.infos.reduce(function(m, pi){
            const cc3 = getCountryCode3(pi.countryCode);
            if(!m[cc3]) {
                m[cc3] = [pi.trendDev7d*100, pi.total];
                return m;
            }
            let cur = m[cc3];
            let newTotal=pi.total+cur[1];
            let newTrend = (cur[0]*cur[1]+pi.trendDev7d*100*pi.total)/newTotal;
            m[cc3] = [newTrend, newTotal];
            return m;
        },{});
        let dataWeek = Object.keys(reducedWeek).map(function(k) {
            let value = reducedWeek[k][0]>0 ? reducedWeek[k][0]*10000 : 1;
            return [k, reducedWeek[k][0], '<strong>'+self.formatPercentage(reducedWeek[k][0])+'</strong> weekly trend'];
        });
        dataWeek = dataWeek.filter(i => i[1]>0);*/

        // sort and filter little samples?
        let countryStats = probeInfo.infos.filter(i => i.total>=50);
        countryStats.sort(function (a, b) { return b.trendDev30d - a.trendDev30d });

        const reducedMonth = countryStats.reduce(function(m, pi){
            const cc3 = getCountryCode3(pi.countryCode);
            if(!m[cc3]) {
                m[cc3] = [pi.trendDev30d*100, pi.total, pi.trendDev30d*100];
                return m;
            }
            let cur = m[cc3];
            let newTotal=pi.total+cur[1];
            let newTrend = (cur[0]*cur[1]+pi.trendDev30d*100*pi.total)/newTotal;
            let maxTrend = pi.trendDev30d*100;
            if (cur[2]>maxTrend) maxTrend=cur[2];
            m[cc3] = [newTrend, newTotal, maxTrend];
            return m;
        },{});
        let dataMonth = Object.keys(reducedMonth).map(function(k) {
            const avgTrend = reducedMonth[k][0];
            const superAvg = (avgTrend + reducedMonth[k][2]) / 2;
            //let value = avgTrend>0 ? reducedMonth[k][0]*10000 : 1;
            return [k, superAvg, '<strong>'+self.formatPercentage(avgTrend)+'</strong> monthly trend'];
        });
        dataMonth = dataMonth.filter(i => i[1]>0);

        return (
            <div>
                <AppNavbar />

                <main id="content" role="main">
                    <div className="container space-bottom-2">
                        <div className="w-lg-80 mx-lg-auto">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-no-gutter font-size-1 space-1">
                                    <li className="breadcrumb-item"><Link to="/">Internet</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Internet Outage Trends</li>
                                </ol>
                            </nav>

                            <div className="card shadow-sm p-7">
                                <h1 className="h2 font-weight-medium">Internet Outage Trends</h1>
                                <h1 className="h6">Latest country and region trends of Internet connection stability worldwide.</h1>

                                <p></p>
                                <div className="mb-4">
                                    <div className="mt-3 mb-3">
                                        <h3 className="h5 mt-2 font-weight-medium">Connectivity drop trends: monthly</h3>
                                        <ChoroplethMap data={dataMonth} colorRange={["#eeaaaa", "#ee0000"]} />
                                    </div>

                                    <table className="table table-borderless table-striped mb-5" width="80%">
                                        <thead>
                                            <tr role="row">
                                                <th><small className="fa fa-map mr-1" />Where</th>
                                                <th><small className="fas fa-chart-line mr-1" />30D</th>
                                                <th><small className="fas fa-chart-line mr-1" />7D</th>
                                                <th><small className="fas fa-users mr-1" />Probes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {countryStats.map((info, index) => this.renderProbeInfo(info, index + 1, (index % 2 === 0)))}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </main>
                <AppFooter/>
            </div>
        );
    }
}

export default OutageTrends;